// extracted by mini-css-extract-plugin
export var askAiIcon = "_ob-9";
export var container = "_ob-0";
export var groupSeparator = "_ob-a";
export var highlight = "_ob-4";
export var resultIcon = "_ob-5";
export var resultItem = "_ob-7";
export var resultSubtitle = "_ob-3";
export var resultTitle = "_ob-2";
export var resultsList = "_ob-1";
export var searchGroup = "_ob-6";
export var selected = "_ob-8";